import * as Yup from 'yup';

import { VALIDATIONS_ERROR } from '~constants/index';

export const FIELDS_NAME = {
  NAME: 'name',
} as const;

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getInitialValues = (defaultName?: string) => ({
  [FIELDS_NAME.NAME]: defaultName ?? '',
});

export const validationSchema = Yup.object().shape({
  [FIELDS_NAME.NAME]: Yup.string().required(VALIDATIONS_ERROR.REQUIRED),
});
